import type { ReactNode } from 'react';

export type NavIconName =
  | 'chart'
  | 'spark'
  | 'bank'
  | 'swap'
  | 'card'
  | 'calendar'
  | 'wallet'
  | 'filter'
  | 'target'
  | 'gear'
  | 'more';

const PATHS: Record<NavIconName, ReactNode> = {
  chart: (
    <>
      <path d="M4 20V11M10 20V4M16 20v-6M3 20h18" />
    </>
  ),
  spark: <path d="m12 2 1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z" />,
  bank: (
    <>
      <path d="m12 3 9 5H3l9-5ZM5 10v8m4.7-8v8m4.6-8v8m4.7-8v8M3 20h18" />
    </>
  ),
  swap: (
    <>
      <path d="M4 8h14m-4-4 4 4-4 4M20 16H6m4 4-4-4 4-4" />
    </>
  ),
  card: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="3" />
      <path d="M3 10h18M7 15h3" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2.5" />
      <path d="M3 10h18M8 3v4m8-4v4" />
    </>
  ),
  wallet: (
    <>
      <path d="M3.5 7.5A2.5 2.5 0 0 1 6 5h11.5v2.5M3.5 7.5V18A2.5 2.5 0 0 0 6 20.5h13V7.5H6a2.5 2.5 0 0 1-2.5-2.5" />
      <circle cx="15.5" cy="14" r="1.2" />
    </>
  ),
  filter: <path d="M3.5 5h17l-6.5 8v6l-4-2.2V13z" />,
  target: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="4.5" />
      <circle cx="12" cy="12" r="1" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2.5v2.8m0 13.4v2.8M2.5 12h2.8m13.4 0h2.8M5.3 5.3l2 2m7.4 7.4 2 2m2-11.4-2 2m-9.4 9.4-2 2" />
    </>
  ),
  more: (
    <>
      <circle cx="5" cy="12" r="1.2" fill="currentColor" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" />
      <circle cx="19" cy="12" r="1.2" fill="currentColor" />
    </>
  ),
};

export function NavIcon({
  name,
  className = 'h-5 w-5',
}: {
  name: NavIconName;
  className?: string;
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      {PATHS[name]}
    </svg>
  );
}
